import React, { useEffect, useRef, useState } from 'react';
import './SetKitchenPrint.scss';
import moment from 'moment';
import RadioButtonGroup from "../../../../Components/RadioButtonGroup/RadioButtonGroup";
import { Button } from '../../../../Components/StyledComponents';
import CheckBox from '../../../../Components/CheckBox/CheckBox';

const SetKitchenPrint = (props) => {
    const normal = 0.34
    const double = normal * 2
    const normal_height = 0.5
    const double_height = normal_height * 2

    useEffect(() => {
        if(Object.keys(props.kitchen_print).length > 0) {
            setFontSize(props.kitchen_print)
        }
    }, [])

    const [font_size, setFontSize] = useState({
        line: 'slim',
        table: {
            size: 'large',
            bold: false,
            width: double,
            height: double_height
        },
        order_no: {
            size: 'large',
            bold: false,
            width: double,
            height: double_height
        },
        menu: {
            size: 'small',
            bold: false,
            width: normal,
            height: normal_height
        },
        option: {
            size: 'small',
            bold: false,
            width: normal,
            height: normal_height
        }
    });
    
    const calcRenderSize = (size) => {
        let default_obj = {
            size: size
        }

        switch(size) {
            case 'small':
                return {
                    ...default_obj,
                    width: normal,
                    height: normal_height
                }
            case 'normal':
                return {
                    ...default_obj,
                    width: double,
                    height: normal_height
                }
            case 'large':
                return {
                    ...default_obj,
                    width: double,
                    height: double_height
                }
        }
    }

    const render_newline = () => {
        switch(font_size.line) {
            case 'slim':
                return <div style={{height: 10}}/>
            case 'normal':
                return <div style={{height: 20}}/>
            case 'wide':
                return <div style={{height: 30}}/>
        }
    }

    return (
        <div className='set-delivery-area'>
            <div className='row' style={{justifyContent:'space-between'}}>
                <div style={{justifyContent: 'center', flex: 1}}>
                    <div style={{width: 298.583, padding: 2, borderWidth: 0.5, borderStyle: 'solid'}}>
                        <br />
                        <br />
                        <div style={{ textAlign: 'center' }}>
                            시럽프렌즈 주방주문서 
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <p>------------------------------------------</p>
                        </div>
                        <div style={{textAlign: 'center'}}>
                        <div>
                                <svg preserveAspectRatio="none" viewBox="0 0 100 19" width={font_size.table.width * 7 + 'cm'} height={font_size.table.height + 'cm'}>
                                    <foreignObject height="100%" width="100%">
                                        <div style={{fontWeight: font_size.table.bold ? 'bold' : 'normal'}}>
                                            테이블: 12
                                        </div>
                                    </foreignObject>
                                </svg>
                            </div>
                            <div>
                                <svg preserveAspectRatio="none" viewBox="0 0 100 19" width={font_size.order_no.width * 7 + 'cm'} height={font_size.order_no.height + 'cm'}>
                                    <foreignObject height="100%" width="100%">
                                        <div style={{fontWeight: font_size.order_no.bold ? 'bold' : 'normal'}}>
                                            주문번호: 2
                                        </div>
                                    </foreignObject>
                                </svg>
                            </div>

                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <p>------------------------------------------</p>
                        </div>
                        <div className='row' style={{paddingLeft: 5, paddingRight: 5, justifyContent:'space-between'}}>
                            <p>메뉴명</p>
                            <p>수량</p>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <p>------------------------------------------</p>
                        </div>
                        <div>
                            <div className='row' style={{ paddingLeft: 5, paddingRight: 5, justifyContent:'space-between'}}>
                                <svg preserveAspectRatio="none" viewBox="0 0 100 19" width={font_size.menu.width * 7 + 'cm'} height={font_size.menu.height + 'cm'}>
                                    <foreignObject height="100%" width="100%">
                                        <div style={{fontWeight: font_size.menu.bold ? 'bold' : 'normal'}}>
                                            아메리카노
                                        </div>
                                    </foreignObject>
                                </svg>
                                <svg preserveAspectRatio="none" viewBox="0 0 100 19" width={font_size.menu.width * 7 + 'cm'} height={font_size.menu.height + 'cm'}>
                                    <foreignObject height="100%" width="100%">
                                        <div style={{textAlign: 'end', fontWeight: font_size.menu.bold ? 'bold' : 'normal'}}>
                                            1
                                        </div>
                                    </foreignObject>
                                </svg>
                            </div>
                            <div className='row' style={{ paddingLeft: 5, paddingRight: 5, justifyContent:'space-between'}}>
                                <svg preserveAspectRatio="none" viewBox="0 0 100 19" width={font_size.option.width * 7 + 'cm'} height={font_size.option.height + 'cm'}>
                                    <foreignObject height="100%" width="100%">
                                        <div style={{fontWeight: font_size.option.bold ? 'bold' : 'normal'}}>
                                            &nbsp;- 라지
                                        </div>
                                    </foreignObject>
                                </svg>
                            </div>
                            <div className='row' style={{ paddingLeft: 5, paddingRight: 5, justifyContent:'space-between'}}>
                                <svg preserveAspectRatio="none" viewBox="0 0 100 19" width={font_size.option.width * 7 + 'cm'} height={font_size.option.height + 'cm'}>
                                    <foreignObject height="100%" width="100%">
                                        <div style={{fontWeight: font_size.option.bold ? 'bold' : 'normal'}}>
                                            &nbsp;- 얼음많이
                                        </div>
                                    </foreignObject>
                                </svg>
                            </div>
                        </div>
                        {render_newline()}
                        <div className='row' style={{paddingLeft: 5, paddingRight: 5, justifyContent:'space-between'}}>
                            <svg preserveAspectRatio="none" viewBox="0 0 100 19" width={font_size.menu.width * 7 + 'cm'} height={font_size.menu.height + 'cm'}>
                                <foreignObject height="100%" width="100%">
                                    <div style={{fontWeight: font_size.menu.bold ? 'bold' : 'normal'}}>
                                        토마토 파스타
                                    </div>
                                </foreignObject>
                            </svg>
                            <svg preserveAspectRatio="none" viewBox="0 0 100 19" width={font_size.menu.width * 7 + 'cm'} height={font_size.menu.height + 'cm'}>
                                <foreignObject height="100%" width="100%">
                                    <div style={{textAlign: 'end', fontWeight: font_size.menu.bold ? 'bold' : 'normal'}}>
                                        13
                                    </div>
                                </foreignObject>
                            </svg>
                        </div>
                        {render_newline()}
                        <div className='row' style={{paddingLeft: 5, paddingRight: 5, justifyContent:'space-between'}}>
                            <svg preserveAspectRatio="none" viewBox="0 0 100 19" width={font_size.menu.width * 7 + 'cm'} height={font_size.menu.height + 'cm'}>
                                <foreignObject height="100%" width="100%">
                                    <div style={{fontWeight: font_size.menu.bold ? 'bold' : 'normal'}}>
                                        베이컨 리조또
                                    </div>
                                </foreignObject>
                            </svg>
                            <svg preserveAspectRatio="none" viewBox="0 0 100 19" width={font_size.menu.width * 7 + 'cm'} height={font_size.menu.height + 'cm'}>
                                <foreignObject height="100%" width="100%">
                                    <div style={{textAlign: 'end', fontWeight: font_size.menu.bold ? 'bold' : 'normal'}}>
                                        2
                                    </div>
                                </foreignObject>
                            </svg>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <p>------------------------------------------</p>
                        </div>
                        <div style={{paddingLeft: 5, paddingRight: 5}}>
                            {moment().format('YY-MM-DD HH:mm:ss')}
                        </div>
                        <br/>
                    </div>
                </div>
                <div className='area' style={{flex: 1}}>
                    <div className='info-box'>
                        <p className='info-box-title' style={{color: '#000', borderBottomWidth: 0}}>메뉴 간격</p>
                        <div className='header-divider' />
                        <RadioButtonGroup
                            perRows={3}
                            value={font_size.line}
                            id='line'
                            onChange={(value) => { setFontSize({...font_size, line: value}) }}
                            options={[
                                { label: '좁게', value: 'slim' },
                                { label: '기본', value: 'normal' },
                                { label: '넓게', value: 'wide' }
                            ]}
                            containerStyle={{ justifyContent: 'center' }}
                        />
                        <div className='row' style={{justifyContent:'space-between', marginTop: 64}}>
                            <p className='info-box-title' style={{color: '#000', borderBottomWidth: 0}}>메뉴명</p>
                            <CheckBox checked={font_size.menu.bold} label={'굵게'} onChange={() => setFontSize({...font_size, menu: {...font_size.menu, bold: !font_size.menu.bold}})}/>
                        </div>
                        <div className='header-divider' />
                        <RadioButtonGroup
                            perRows={3}
                            value={font_size.menu.size}
                            id='menu_title'
                            onChange={(value) => { setFontSize({...font_size, menu: {...font_size.menu, ...calcRenderSize(value)}}) }}
                            options={[
                                { label: '작게', value: 'small' },
                                { label: '기본', value: 'normal' },
                                { label: '크게', value: 'large' }
                            ]}
                            containerStyle={{ justifyContent: 'center' }}
                        />
                        <div className='row' style={{justifyContent:'space-between', marginTop: 64}}>
                            <p className='info-box-title' style={{color: '#000', borderBottomWidth: 0}}>옵션명</p>
                            <CheckBox checked={font_size.option.bold} label={'굵게'} onChange={() => setFontSize({...font_size, option: {...font_size.option, bold: !font_size.option.bold}})}/>
                        </div>
                        <div className='header-divider' />
                        <RadioButtonGroup
                            perRows={3}
                            value={font_size.option.size}
                            id='option_title'
                            onChange={(value) => { setFontSize({...font_size, option: {...font_size.option, ...calcRenderSize(value)}}) }}
                            options={[
                                { label: '작게', value: 'small' },
                                { label: '기본', value: 'normal' },
                                { label: '크게', value: 'large' }
                            ]}
                            containerStyle={{ justifyContent: 'center' }}
                        />
                        <div className='row' style={{justifyContent:'space-between', marginTop: 64}}>
                            <p className='info-box-title' style={{color: '#000', borderBottomWidth: 0}}>테이블</p>
                            <CheckBox checked={font_size.table.bold} label={'굵게'} onChange={() => setFontSize({...font_size, table: {...font_size.table, bold: !font_size.table.bold}})}/>
                        </div>
                        <div className='header-divider' />
                        <RadioButtonGroup
                            perRows={3}
                            value={font_size.table.size}
                            id='otable_title'
                            onChange={(value) => { setFontSize({...font_size, table: {...font_size.table, ...calcRenderSize(value)}}) }}
                            options={[
                                { label: '작게', value: 'small' },
                                { label: '기본', value: 'normal' },
                                { label: '크게', value: 'large' }
                            ]}
                            containerStyle={{ justifyContent: 'center' }}
                        />
                        <div className='row' style={{justifyContent:'space-between', marginTop: 64}}>
                            <p className='info-box-title' style={{color: '#000', borderBottomWidth: 0}}>주문번호</p>
                            <CheckBox checked={font_size.order_no.bold} label={'굵게'} onChange={() => setFontSize({...font_size, order_no: {...font_size.order_no, bold: !font_size.order_no.bold}})}/>
                        </div>
                        <div className='header-divider' />
                        <RadioButtonGroup
                            perRows={3}
                            value={font_size.order_no.size}
                            id='order_no_title'
                            onChange={(value) => { setFontSize({...font_size, order_no: {...font_size.order_no, ...calcRenderSize(value)}}) }}
                            options={[
                                { label: '작게', value: 'small' },
                                { label: '기본', value: 'normal' },
                                { label: '크게', value: 'large' }
                            ]}
                            containerStyle={{ justifyContent: 'center' }}
                        />
                    </div>
                </div>
            </div>
            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => props.patchKitchenPrint(font_size)}>
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default SetKitchenPrint;